"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncateText = exports.formatStringToDisplayCase = exports.formatPhoneNumberFromNumber = exports.formatPhone = exports.formatNumberWithCommas = exports.formatDistance = exports.formatDealerName = void 0;
var formatNumberWithCommas = exports.formatNumberWithCommas = function formatNumberWithCommas(x) {
  if (!x) {
    return '';
  }
  var parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};
var formatStringToDisplayCase = exports.formatStringToDisplayCase = function formatStringToDisplayCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  }).replace('Of', 'of').replace(' Ii', ' II');
};
var formatDealerName = exports.formatDealerName = function formatDealerName(str) {
  var dealerName;
  var dealerNameSet;
  var dealerNameFormatted;
  if (str.indexOf('-') >= 7) {
    dealerName = str.replace('-', ' of ');
    dealerNameSet = formatStringToDisplayCase(dealerName);
  } else if (str === 'A-1 HOMES-DONNA') {
    dealerNameSet = 'A-1 Homes of Donna';
  } else {
    dealerNameSet = formatStringToDisplayCase(str);
  }
  if (dealerNameSet.indexOf('Llc') >= 7) {
    dealerName = dealerNameSet.replace('Llc', 'LLC');
    dealerNameFormatted = dealerName;
  } else {
    dealerNameFormatted = dealerNameSet;
  }
  return dealerNameFormatted;
};
var formatPhoneNumberFromNumber = exports.formatPhoneNumberFromNumber = function formatPhoneNumberFromNumber(phone) {
  if (phone && phone.length === 10) {
    return "(".concat(phone.substr(0, 3), ") ").concat(phone.substr(3, 3), "-").concat(phone.substr(6, 4));
  }
  return null;
};
var formatPhone = exports.formatPhone = function formatPhone(phone) {
  return formatPhoneNumberFromNumber(phone);
};
var formatDistance = exports.formatDistance = function formatDistance(distance) {
  var formattedDistance = distance.toFixed(1);
  if (formattedDistance % 1 === 0) {
    return distance.toFixed(0);
  }
  return formattedDistance;
};
var truncateText = exports.truncateText = function truncateText(text, limit) {
  if (text.length <= limit) {
    return text;
  }
  var lastSpaceIndex = text.substring(0, limit).lastIndexOf(' ');
  return text.substring(0, lastSpaceIndex) + "...";
};